import HTTP from '@/utils/http'

class UsercenterModel extends HTTP {
  /**
   * @description Lily-学习端 PC登录
   * @param {Object} data
   * @see http://yapi.lilyenglish.cn/project/57/interface/api/8551
   */
  login(data) {
    return this.post({
      url: '/usercenter/user/pc/phone/login',
      data,
    })
  }

  /**
   * @description 用户登出
   * @param {Object} data
   * @see http://yapi.lilyenglish.cn/project/57/interface/api/5863
   */
  logout(userId) {
    return this.post({
      url: `/usercenter/user/logout?userId=${userId}`,
    })
  }

  /**
   * @description web短信验证码（需要先获取图形验证码）
   * @param {Object} params
   * @see http://yapi.lilyenglish.cn/project/57/interface/api/1527
   */
  getVerifyCode(params) {
    return this.get({
      url: '/usercenter/common/verifyCode',
      params,
    })
  }

  /**
   *
   * 获取钻石的字典值
   *
   */
  getJewel_type() {
    return this.get({
      url: '/cmscore/dict',
    })
  }

  /***
   *
   * 获取token
   *
   */
  getTokenCode(params) {
    return this.get({
      url: '/usercenter/user/init/token/code',
      headers: {
        token: params.token,
      },
    })
  }

  /**
   * @description 获取手机号
   * @see none
   */
  phone() {
    return this.get({
      url: '/usercenter/user/phone',
    })
  }

  /**
   * @description LILY学习端 PC 右上角用户信息
   * @param {Object}
   * @see http://yapi.lilyenglish.cn/project/97/interface/api/8581
   */
  getUser() {
    // 服务端简化服务，迁移接口
    const user = JSON.parse(localStorage.getItem('USER'))
    return this.get({
      url: '/usercenter/user/student/center/info',
      params: {
        userId: user ? user.id || user.userId : '',
      },
    })
  }

  /**
   * 获取用户信息
   * @param {*} userCode 
   */
  getUserInfo(userCode) {
    return this.get({
      url: '/usercenter/user/code',
      params: {
        code: userCode,
      },
    })
  }
}

// 存储用户KEY
UsercenterModel.USER_INFO_KEY = 'USER'

export default UsercenterModel
